module.exports = __webpack_public_path__ + "img/welcome-bg-2.46914f51.png";